import api from "./index";

export const login = async (username: string, password: string) => {
    const params = new URLSearchParams();
    params.append("username", username);
    params.append("password", password);

    const response = await api.post("/auth", params, {
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
    });

    const { access_token, refresh_token } = response.data;
    if (access_token && refresh_token) {
        localStorage.setItem("access_token", access_token);
        localStorage.setItem("refresh_token", refresh_token);
    }

    return response.data;
};

export const logout = async () => {
    try {
        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");
        window.location.replace("/login");
    } catch (err) {
        console.error("Logout failed", err);
    }
};
export const refreshAccessToken = async (): Promise<string> => {
    const refresh_token = localStorage.getItem("refresh_token");
    if (!refresh_token) throw new Error("No refresh token");

    try {
        const response = await api.post("/refresh", { refresh_token });

        const newAccessToken = response.data.access_token;

        if (!newAccessToken) throw new Error("Could not refresh token");

        localStorage.setItem("access_token", newAccessToken);
        return newAccessToken;
    } catch (err: any) {
        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");
        if (!window.location.pathname.includes("/login")) {
            window.location.replace("/login");
        }
        throw new Error("Refresh token expired or invalid");
    }
};
